<wm-form-activity-input-view
  [activity]="activity"
  [form]="form"
  [isReadOnly]="true"
></wm-form-activity-input-view>

<br />
<a [href]="'mailto:' + model.inspection.requestorEmail">Send Message </a> to
requestor.
